import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeadlineInputComponent } from './components/headline-input/headline-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { ExpandableCheckboxListComponent } from './components/expandable-checkbox-list/expandable-checkbox-list.component';
import { ExpandableSectionBoxComponent } from './components/expandable-section-box/expandable-section-box.component';
import { ExpandableDropdownComponent } from './components/expandable-dropdown/expandable-dropdown.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { ContentStatusCardComponent } from './components/content-status-card/content-status-card.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { InternalInformationComponent } from './components/internal-information/internal-information.component';
import { ContentEditorComponent } from './components/content-editor/content-editor.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MediaAdderComponent } from './components/media-adder/media-adder.component';
import { MediaAdderDialogComponent } from './components/media-adder-dialog/media-adder-dialog.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MediaAdderItemComponent } from './components/media-adder-item/media-adder-item.component';
import { PagerComponent } from '../shared/standalone/components/pager/pager.component';
import { MediaThumbnailComponent } from './components/media-thumbnail/media-thumbnail.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ProcessingBoundaryComponent } from '../shared/standalone/components/processing-boundary/processing-boundary.component';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { ContentStateControlsComponent } from './components/content-state-controls/content-state-controls.component';
import { VersionListComponent } from './components/version-list/version-list.component';
import { RouterModule } from '@angular/router';
import { StandfirstInputComponent } from './components/standfirst-text/standfirst-text.component';
import { ActiveUsersComponent } from './components/active-users/active-users.component';
import { PublishTimeComponent } from './components/publish-time/publish-time.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SearchListComponent } from './components/search-list/search-list.component';
import { AutoCompleteComponent } from './components/auto-complete/auto-complete.component';
import { RelatedDataComponent } from './components/related-data/related-data.component';
import { ContentListComponent } from './components/content-list/content-list.component';
import { RelatedManagerComponent } from './components/related-manager/related-manager.component';
import { RelatedManagerItemComponent } from './components/related-manager-item/related-manager-item.component';
import { TaggingComponent } from './components/tagging/tagging.component';
import { AuthorsComponent } from './components/authors/authors.component';
import { RelatedArticlesComponent } from './components/related-articles/related-articles.component';
import { RelatedArticlesItemComponent } from './components/related-articles-item/related-articles-item.component';
import { ExternalLinksComponent } from './components/external-links/external-links.component';
import { VisibilityComponent } from './components/visibility/visibility.component';
import { SponsorsComponent } from './components/sponsors/sponsors.component';
import { ColumnistContentComponent } from './components/columnist-content/columnist-content.component';
import { SharedModule } from '../shared/shared.module';
import { SponsoredAuthorSectionComponent } from './components/sponsored-author-section/sponsored-author-section.component';
import { AdvertorialClientComponent } from './components/advertorial-client/advertorial-client.component';
import { RepurposedContentComponent } from './components/repurposed-content/repurposed-content.component';
import { AuthorsItemComponent } from './components/authors-item/authors-item.component';
import { TextInputComponent } from './components/text-input/text-input.component';
import { ChaptersComponent } from './components/chapters/chapters.component';
import { MediaAdderCondensedComponent } from './components/media-adder-condensed/media-adder-condensed.component';
import { MediaAdderItemCondensedComponent } from './components/media-adder-item-condensed/media-adder-item-condensed.component';
import { ColourPickerComponent } from './components/colour-picker/colour-picker.component';
import { SlideComponent } from './components/slide/slide.component';
import { SlideListComponent } from './components/slide-list/slide-list.component';
import { AutoCompleteWithAddComponent } from './components/auto-complete-with-add/auto-complete-with-add.component';
import { DigitalPublicationSectionComponent } from './components/digital-publication-section/digital-publication-section.component';
import { DigitalPublicationSectionListComponent } from './components/digital-publication-section-list/digital-publication-section-list.component';
import { ProfileStatusCardComponent } from './components/profile-status-card/profile-status-card.component';
import { MatMenuModule } from '@angular/material/menu';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SurtitlesComponent } from './components/surtitles/surtitles.component';
import { TagButtonComponent } from './components/tag-button/tag-button.component';
import { SmartLinkCardComponent } from './components/smart-link-card/smart-link-card.component';
import { SmartLinkStrengthComponent } from './components/smart-link-strength/smart-link-strength.component';
import { AiIconComponent } from './components/ai-icon/ai-icon.component';
import { AiActionButtonComponent } from './components/ai-action-button/ai-action-button.component';

@NgModule({
  declarations: [
    HeadlineInputComponent,
    StandfirstInputComponent,
    ExpandableCheckboxListComponent,
    ExpandableSectionBoxComponent,
    ExpandableDropdownComponent,
    ContentStatusCardComponent,
    InternalInformationComponent,
    ContentEditorComponent,
    MediaAdderComponent,
    MediaAdderDialogComponent,
    MediaAdderItemComponent,
    MediaThumbnailComponent,
    ContentStateControlsComponent,
    VersionListComponent,
    ActiveUsersComponent,
    PublishTimeComponent,
    SearchListComponent,
    ContentListComponent,
    RelatedDataComponent,
    RelatedManagerComponent,
    RelatedManagerItemComponent,
    AuthorsComponent,
    RelatedArticlesComponent,
    RelatedArticlesItemComponent,
    ExternalLinksComponent,
    TaggingComponent,
    VisibilityComponent,
    SponsorsComponent,
    ColumnistContentComponent,
    SponsoredAuthorSectionComponent,
    AdvertorialClientComponent,
    RepurposedContentComponent,
    AuthorsItemComponent,
    TextInputComponent,
    ChaptersComponent,
    MediaAdderCondensedComponent,
    MediaAdderItemCondensedComponent,
    ColourPickerComponent,
    SlideComponent,
    SlideListComponent,
    AutoCompleteWithAddComponent,
    DigitalPublicationSectionComponent,
    DigitalPublicationSectionListComponent,
    ProfileStatusCardComponent,
    SurtitlesComponent,
    TagButtonComponent,
    SmartLinkCardComponent,
    SmartLinkStrengthComponent,
    AiIconComponent,
    AiActionButtonComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    // Material
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatSelectModule,
    MatOptionModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatChipsModule,
    MatIconModule,
    DragDropModule,
    MatTooltipModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    // External
    EditorModule,
    // Local
    // Standalone
    PagerComponent,
    ProcessingBoundaryComponent,
    AutoCompleteComponent,
    DragDropModule,
    SharedModule,
    MatMenuModule, // Menu component
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    // Material
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatButtonModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatIconModule,
    DragDropModule,
    MatTooltipModule,
    // Local
    HeadlineInputComponent,
    StandfirstInputComponent,
    ExpandableCheckboxListComponent,
    ExpandableSectionBoxComponent,
    ExpandableDropdownComponent,
    ContentStatusCardComponent,
    InternalInformationComponent,
    ContentEditorComponent,
    MediaAdderComponent,
    MediaAdderDialogComponent,
    MediaAdderItemComponent,
    MediaThumbnailComponent,
    ContentStateControlsComponent,
    VersionListComponent,
    ActiveUsersComponent,
    PublishTimeComponent,
    SearchListComponent,
    ContentListComponent,
    RelatedDataComponent,
    AiActionButtonComponent,
    AuthorsComponent,
    RelatedArticlesComponent,
    ExternalLinksComponent,
    TaggingComponent,
    VisibilityComponent,
    SponsorsComponent,
    ColumnistContentComponent,
    SponsoredAuthorSectionComponent,
    AdvertorialClientComponent,
    RepurposedContentComponent,
    TextInputComponent,
    ChaptersComponent,
    MediaAdderCondensedComponent,
    MediaAdderItemCondensedComponent,
    ColourPickerComponent,
    SlideComponent,
    SlideListComponent,
    AutoCompleteWithAddComponent,
    DigitalPublicationSectionComponent,
    DigitalPublicationSectionListComponent,
    ProfileStatusCardComponent,
    SurtitlesComponent,
  ],
})
export class SharedFormSectionsModule {}
